import { useFetch } from './useFetch'

export const useReportService = () => {
  const fetch = useFetch()

  const listarReportsAsync = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/report`)
      return response.data.report
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarReportAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/report/${id}`)
      return response.data.report
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarReportDeUsuarioAsync = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/report/todos/deusuario/`)
      return response.data.reports
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarReport = async (dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosReport = {
        tipoReport: dados.tipoReport,
        descricao: dados.descricao,
        arquivos: dados.arquivos,
      }
      await fetch.postOpen('/report', dadosReport)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const gerenciarReport = async (id, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosEdicao = {
        status: dados.statusAtual,
      }
      await fetch.putOpen(`/report/${id}`, dadosEdicao)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return {
    listarReportsAsync,
    listarReportAsync,
    listarReportDeUsuarioAsync,
    cadastrarReport,
    gerenciarReport,
  }
}
